<template>
  <div>
    <BreadcrumbBanner
      :pageTitle="$t('Populars Game')"
      :links="[
        { name: $t('Home'), url: '/' },
        { name: $t('Populars Game') }
      ]"
    />

    <!--Casino Demo-->
    <div class="casino-demo pb-60 pb-60">
      <div class="container-fluid">
        <div class="all-games-wrapper mt-5">
          <div class="section-wrapper live-section-wrapper">
            <h4 class="left-title live-text d-flex align-items-center">
              <span class="icon">
                <img src="@/assets/img/casino/live/pop.png" alt="badge" />
              </span>
              {{ $t("All Games") }}
              <span class="text-base text">{{ games.length }} </span>
            </h4>
          </div>
          <div class="row g-3">
            <div v-for="game in games" :key="game.id" class="col-xxl-3 col-xl-4 col-md-4 col-sm-6">
              <GameCard :game="game" />
            </div>
          </div>
        </div>
      </div>
      <div class="more-btn text-center bt" v-if="nextPage != null">
        <a href="javascript:;" class="border-btn" @click="loadMore">
          <span>{{ $t("Load more") }}</span>
        </a>
      </div>
    </div>
    <!--Casino Demo-->

  </div>
  <!--Middle Body-->
</template>

<script>
import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { usePopularsGamesStore } from "@/store/popularsGames";
import { mapState, mapActions } from "pinia";
import GameCard from "@/components/partials/GameCard.vue";

export default {
  name: "PopularGamesPage",
  components: {
    BreadcrumbBanner,
    GameCard,
  },
  computed: {
    ...mapState(usePopularsGamesStore, ["games", "nextPage"]),
  },
  methods: {
    ...mapActions(usePopularsGamesStore, ["loadMostCommented"]),
    async loadMore() {
      await this.loadMostCommented();
    },
  },
  async mounted() {
    this.nextPage = 1;
    await this.loadMostCommented();
  },
};
</script>
